import {HashWizardHelpers} from "../../../../../common/components/wizards/HashWizardHelpers";
import {useParams} from "react-router-dom";
import {useControllers} from "../../../../../../../common/helpers/react/hooks/useControllers";
import {asNumber} from "../../../../../../../common/helpers/converters/asNumber";
import LoadingBlock from "../../../../../common/placeholders/loading/LoadingBlock";
import GroupWizardApplicationStepAccordion from "./GroupWizardApplicationStepAccordion";

export type GroupWizardApplicationStepFormPresenterProps = {
    wizardHelpers: Pick<HashWizardHelpers, 'stepData' | 'setStepData' | 'isLoading' | 'step' | 'isEditing'>;
}

export default function GroupWizardApplicationStepFormPresenter(props: GroupWizardApplicationStepFormPresenterProps) {
    const wh = props.wizardHelpers;
    const {id} = useParams();

    const groups = useControllers().groups;
    const group = groups.getGroupById$(asNumber(id)).useState();

    if (wh.isLoading || (wh.isEditing && !group)) {
        return <LoadingBlock height={60}/>;
    }

    return <GroupWizardApplicationStepAccordion/>
}